import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Routable::SetNewPassword @resetToken={{@model.resetToken}} />",{ moduleName: "mewe/templates/set-new-password.hbs" })